import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getCompatibilityYearGroup = createAsyncThunk('compatibility/getCompatibilityYearGroup',
  async ({ make, model, refresh }, { rejectWithValue }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/compatibility/year', { make, model, group: true });
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return { data, refresh };
    } catch (error) {
      return rejectWithValue(error?.data.message);
    }
  });

export const setCompatibilityYearGroup = createAction('compatibility/setCompatibilityYearGroup');

export default getCompatibilityYearGroup;
